/**
 * format.ts — การจัดรูปแบบข้อความที่ต้องเหมือนกันทุกที่ (web, mobile, PDF)
 */
import { round2 } from './money.js';
/**
 * จัดรูปแบบจำนวนเงิน: 1234567.891 -> "1,234,567.89"
 * ไม่ใส่สัญลักษณ์สกุลเงิน เพราะบางที่ต้องการ ฿ บางที่ไม่ต้องการ
 */
export function formatMoney(value) {
    const rounded = round2(Number.isFinite(value) ? value : 0);
    return rounded.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}
/** จัดรูปแบบจำนวนเงินพร้อมสัญลักษณ์บาท */
export function formatBaht(value) {
    return `฿${formatMoney(value)}`;
}
/**
 * จัดรูปแบบจำนวน (ปริมาณสินค้า) — ตัดศูนย์ท้ายทศนิยมออก
 * 2 -> "2", 2.5 -> "2.5", 2.50 -> "2.5"
 */
export function formatQuantity(value) {
    if (!Number.isFinite(value))
        return '0';
    return String(parseFloat(value.toFixed(3)));
}
/** วันที่แบบไทย dd/mm/yyyy (ปี ค.ศ.) — ตรงกับเอกสารเดิม */
export function formatDate(value) {
    const date = toDate(value);
    if (!date)
        return '-';
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${dd}/${mm}/${date.getFullYear()}`;
}
const THAI_MONTHS_SHORT = [
    'ม.ค.',
    'ก.พ.',
    'มี.ค.',
    'เม.ย.',
    'พ.ค.',
    'มิ.ย.',
    'ก.ค.',
    'ส.ค.',
    'ก.ย.',
    'ต.ค.',
    'พ.ย.',
    'ธ.ค.',
];
const THAI_MONTHS_FULL = [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
];
/** วันที่แบบอ่านง่าย: "7 ก.ย. 2569" (ปี พ.ศ.) */
export function formatDateThai(value) {
    const date = toDate(value);
    if (!date)
        return '-';
    return `${date.getDate()} ${THAI_MONTHS_SHORT[date.getMonth()]} ${date.getFullYear() + 543}`;
}
/** เดือน/ปีแบบเต็ม: "กันยายน 2569" */
export function formatMonthYearThai(year, month) {
    const name = THAI_MONTHS_FULL[Math.min(Math.max(month, 1), 12) - 1];
    return `${name} ${year + 543}`;
}
export function thaiMonthName(month, style = 'full') {
    const index = Math.min(Math.max(month, 1), 12) - 1;
    return style === 'short'
        ? THAI_MONTHS_SHORT[index]
        : THAI_MONTHS_FULL[index];
}
/**
 * จัดรูปแบบเลขประจำตัวผู้เสียภาษี 13 หลัก: 0105561000000 -> "0-1055-61000-00-0"
 * ถ้าไม่ใช่ 13 หลักคืนค่าเดิม
 */
export function formatTaxId(taxId) {
    const digits = (taxId ?? '').replace(/\D/g, '');
    if (digits.length !== 13)
        return taxId ?? '';
    return `${digits.slice(0, 1)}-${digits.slice(1, 5)}-${digits.slice(5, 10)}-${digits.slice(10, 12)}-${digits.slice(12)}`;
}
/** แสดงชื่อสาขา: "00000" -> "สำนักงานใหญ่", อื่นๆ -> "สาขา 00001" */
export function formatBranch(branch) {
    const value = (branch ?? '').trim();
    if (value === '' || value === '00000')
        return 'สำนักงานใหญ่';
    if (/^\d+$/.test(value))
        return `สาขา ${value}`;
    return value;
}
/** ตัดข้อความให้สั้นลงพร้อมจุดไข่ปลา */
export function truncate(text, maxLength) {
    if (text.length <= maxLength)
        return text;
    return text.slice(0, Math.max(0, maxLength - 1)).trimEnd() + '…';
}
function toDate(value) {
    if (!value)
        return null;
    const date = value instanceof Date ? value : new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
//# sourceMappingURL=format.js.map